/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

/**
* ExclusionAddressesFileMetaData carries metadata for an exclusion-address upload (currently just the uploaded file name).
*/
export class V1ExclusionAddressesFileMetaData {
    /**
    * Original name of the uploaded CSV file
    */
    'fileName'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "fileName",
            "baseName": "file_name",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1ExclusionAddressesFileMetaData.attributeTypeMap;
    }

    public constructor() {
    }
}

